const X_TVOD_AUTHORIZATION = 'X-Tvod-Authorization';
export const getPPGHeaders = (tvodToken: string | null) =>
  tvodToken ? { [X_TVOD_AUTHORIZATION]: tvodToken } : null;
const X_ADOBE_AUTHORIZATION = 'X-Adobe-Authorization';
export const getTveHeaders = (tveToken: string | null) =>
  tveToken ? { [X_ADOBE_AUTHORIZATION]: tveToken } : null;
